// extracted by mini-css-extract-plugin
export default {"advertCardPhoto":"c-a_gK","advertCardPhoto__image":"c-a_gL"};